// =====================================
// src/index.js  (Create React App) — Router robusto
// - Si la URL es /quote/:quoteNumber/:action -> renderiza QuoteAction
// - En cualquier otro caso -> App (tu panel)
// =====================================
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import QuoteAction from './pages/QuoteAction';
import BodegaAcceso from './pages/BodegaAcceso';
import AsistenciaCoordinador from './pages/AsistenciaCoordinador';
import SafetyPackagePage from './pages/SafetyPackagePage';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    this.setState({ info });
    try { localStorage.setItem('lastAppError', error?.toString() + '\n' + info?.componentStack); } catch(e) {}
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24, fontFamily: 'sans-serif', background: '#fff', minHeight: '100vh' }}>
          <h2 style={{ color: '#dc2626' }}>⚠️ Error en la aplicación</h2>
          <p style={{ color: '#374151', marginBottom: 12 }}>Hubo un error al cargar el sistema. Por favor comparte este mensaje:</p>
          <pre style={{ background: '#f1f5f9', padding: 16, borderRadius: 8, fontSize: 12, overflowX: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-all', color: '#1e293b', border: '1px solid #e2e8f0' }}>
            {this.state.error?.toString()}
            {'\n---\n'}
            {this.state.info?.componentStack}
          </pre>
          <button onClick={() => { localStorage.removeItem('token'); window.location.reload(); }}
            style={{ marginTop: 16, padding: '10px 20px', background: '#6366f1', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14 }}>
            Cerrar sesión y reintentar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const container = document.getElementById('root');
const root = createRoot(container);

const path = typeof window !== 'undefined' ? window.location.pathname : '/';

// ¿Coincide con /quote/XXX/accept o /quote/XXX/modify ?
const isQuoteAction = /^\/quote\/[^/]+\/(accept|modify)\/?$/i.test(path);
// ¿Acceso directo de bodega sin login?
const isBodegaAcceso = /^\/bodega\/acceso\/?$/i.test(path);
// ¿Registro de asistencia por QR (coordinador)?
const isAsistencia = /^\/asistencia\/?$/i.test(path);
// ¿Paquete de seguridad (vista previa/imprimir)?
const isSafetyPackage = /^\/paquete-seguridad\/?$/i.test(path);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          {isSafetyPackage ? (
            <Route path="/paquete-seguridad" element={<SafetyPackagePage />} />
          ) : isAsistencia ? (
            <Route path="/asistencia" element={<AsistenciaCoordinador />} />
          ) : isBodegaAcceso ? (
            <Route path="/bodega/acceso" element={<BodegaAcceso />} />
          ) : isQuoteAction ? (
            <Route path="/quote/:quoteNumber/:action" element={<QuoteAction />} />
          ) : (
            <Route path="/*" element={<App />} />
          )}
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
